module.exports = __webpack_public_path__ + "static/img/loading.459be65.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading.gif
// module id = G/2H
// module chunks = 1